import React from 'react';
import { mockData } from '../mockData';
import { CheckCircle2, Clock, DollarSign } from 'lucide-react';

const StatsSection = () => {
  const icons = [CheckCircle2, Clock, DollarSign];

  return (
    <section className="py-6 bg-navy-800 border-y border-navy-600/50">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-center gap-6 md:gap-16">
          {mockData.stats.map((stat, index) => {
            const Icon = icons[index];
            return (
              <div key={stat.id} className="flex items-center gap-3">
                <div className="bg-gold-400/15 p-2.5 rounded-lg">
                  <Icon className="text-gold-400" size={22} />
                </div>
                <div>
                  <span className="text-2xl font-bold text-white">{stat.value}</span>
                  <span className="text-gray-400 text-sm ml-2">{stat.label}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
